import { Collapse as AntCollapse, CollapseProps } from "antd";
import styled from "styled-components";

export const Collapse: typeof AntCollapse = styled(
  AntCollapse,
)<CollapseProps>``;
